import { useId } from "react";
import type { SVGProps } from "react";

// 에이전트 상세 전용 아이콘 — Figma ver.6 의 공식 SVG 경로예요 (REST /v1/images svg, 2026-10-13 수집).
// 선 색은 currentColor 로 바꿨고, 굵기 · 격자는 시안 그대로라서 격자 크기(size 기본값)로 쓰면 시안과 같아요.
type IconProps = Omit<SVGProps<SVGSVGElement>, "width" | "height"> & { size?: number };

function Icon({ size, grid, children, ...props }: IconProps & { size: number; grid: number }) {
  return (
    <svg width={size} height={size} viewBox={`0 0 ${grid} ${grid}`} fill="none" aria-hidden {...props}>
      {children}
    </svg>
  );
}

// item-svg 546:6599 (도입 대상 · 사용 부서)
export const NvUserIcon = ({ size = 22, ...props }: IconProps) => (
  <Icon size={size} grid={22} {...props}>
    <path d="M11.0013 10.5417C12.7732 10.5417 14.2096 9.10525 14.2096 7.33333C14.2096 5.56142 12.7732 4.125 11.0013 4.125C9.22939 4.125 7.79297 5.56142 7.79297 7.33333C7.79297 9.10525 9.22939 10.5417 11.0013 10.5417Z" stroke="currentColor" />
    <path d="M4.58203 18.3337C5.4987 15.0337 8.06536 13.292 10.9987 13.292C13.932 13.292 16.4987 15.0337 17.4154 18.3337" stroke="currentColor" />
  </Icon>
);

// item-svg 546:6605 (도입 대상 · 도입 가능 기업)
export const NvBuildingIcon = ({ size = 22, ...props }: IconProps) => (
  <Icon size={size} grid={22} {...props}>
    <path d="M3.66797 18.3333V5.5L11.0013 2.75L18.3346 5.5V18.3333" stroke="currentColor" />
    <path d="M8.2487 18.3333V13.75H13.7487V18.3333M7.33203 8.25H8.2487M10.9987 8.25H11.9154M14.6654 8.25H15.582M7.33203 11H8.2487M10.9987 11H11.9154M14.6654 11H15.582" stroke="currentColor" />
  </Icon>
);

// item-svg 546:6611 (도입 대상 · 준비사항)
export const NvListIcon = ({ size = 22, ...props }: IconProps) => (
  <Icon size={size} grid={22} {...props}>
    <path d="M8.25 5.5H18.3333M8.25 11H18.3333M8.25 16.5H18.3333" stroke="currentColor" />
    <path d="M3.66797 5.49967L4.58464 6.41634L6.41797 4.58301M3.66797 10.9997L4.58464 11.9163L6.41797 10.083M3.66797 16.4997L4.58464 17.4163L6.41797 15.583" stroke="currentColor" />
  </Icon>
);

// dt svg 546:6988 (도입 조건 · 배포 방식)
export const NvStackIcon = ({ size = 20, ...props }: IconProps) => (
  <Icon size={size} grid={20} {...props}>
    <path d="M15.4154 3.33301H4.58203C3.89168 3.33301 3.33203 3.89265 3.33203 4.58301V7.08301C3.33203 7.77336 3.89168 8.33301 4.58203 8.33301H15.4154C16.1057 8.33301 16.6654 7.77336 16.6654 7.08301V4.58301C16.6654 3.89265 16.1057 3.33301 15.4154 3.33301Z" stroke="currentColor" />
    <path d="M15.4154 11.667H4.58203C3.89168 11.667 3.33203 12.2266 3.33203 12.917V15.417C3.33203 16.1073 3.89168 16.667 4.58203 16.667H15.4154C16.1057 16.667 16.6654 16.1073 16.6654 15.417V12.917C16.6654 12.2266 16.1057 11.667 15.4154 11.667Z" stroke="currentColor" />
    <path d="M6.66797 5.83301H6.6763M6.66797 14.1663H6.6763" stroke="currentColor" />
  </Icon>
);

// dt svg 546:6996 (도입 조건 · 가격 정책)
export const NvTagIcon = ({ size = 20, ...props }: IconProps) => (
  <Icon size={size} grid={20} {...props}>
    <path d="M2.5 9.99967V3.33301H9.16667L16.6667 10.833L10 17.4997L2.5 9.99967Z" stroke="currentColor" />
    <path d="M6.2513 8.16667C6.84961 8.16667 7.33464 7.68164 7.33464 7.08333C7.33464 6.48502 6.84961 6 6.2513 6C5.65299 6 5.16797 6.48502 5.16797 7.08333C5.16797 7.68164 5.65299 8.16667 6.2513 8.16667Z" stroke="currentColor" />
  </Icon>
);

// dt svg 546:7003 (도입 조건 · PoC)
export const NvFlaskIcon = ({ size = 20, ...props }: IconProps) => (
  <Icon size={size} grid={20} {...props}>
    <path d="M7.49936 2.5H12.4994M8.33269 2.5V7.5L3.74936 15.4167C3.65628 15.6347 3.6162 15.8717 3.63242 16.1082C3.64864 16.3447 3.72069 16.5741 3.84267 16.7773C3.96464 16.9806 4.13307 17.1521 4.33413 17.2777C4.53519 17.4034 4.76317 17.4795 4.99936 17.5H14.9994C15.2356 17.4795 15.4635 17.4034 15.6646 17.2777C15.8657 17.1521 16.0341 16.9806 16.1561 16.7773C16.278 16.5741 16.3501 16.3447 16.3663 16.1082C16.3825 15.8717 16.3424 15.6347 16.2494 15.4167L11.666 7.5V2.5" stroke="currentColor" />
    <path d="M5.83203 12.5H14.1654" stroke="currentColor" />
  </Icon>
);

// dt svg 546:7010 (도입 조건 · 가격대)
export const NvCoinIcon = ({ size = 20, ...props }: IconProps) => (
  <Icon size={size} grid={20} {...props}>
    <path d="M10.0013 17.0837C13.9133 17.0837 17.0846 13.9123 17.0846 10.0003C17.0846 6.08831 13.9133 2.91699 10.0013 2.91699C6.08929 2.91699 2.91797 6.08831 2.91797 10.0003C2.91797 13.9123 6.08929 17.0837 10.0013 17.0837Z" stroke="currentColor" />
    <path d="M12.0846 7.66699C11.5846 7.00033 10.8346 6.66699 9.91797 6.66699C8.58464 6.66699 7.66797 7.33366 7.66797 8.33366C7.66797 9.33366 8.58464 9.75033 10.0013 10.0003C11.418 10.2503 12.3346 10.667 12.3346 11.7503C12.3346 12.8337 11.3346 13.417 10.0013 13.417C9.0013 13.417 8.16797 13.0003 7.66797 12.3337M10.0013 5.41699V14.5837" stroke="currentColor" />
  </Icon>
);

// sub-cta svg 546:6509 (저장 버튼)
export const NvStarOutlineIcon = ({ size = 16, filled = false, ...props }: IconProps & { filled?: boolean }) => (
  <Icon size={size} grid={16} {...props}>
    <path fill={filled ? "currentColor" : "none"} d="M8.00078 1.7998L9.90078 5.6998L14.2008 6.2998L11.1008 9.2998L11.8008 13.5998L8.00078 11.5998L4.20078 13.5998L4.90078 9.2998L1.80078 6.2998L6.10078 5.6998L8.00078 1.7998Z" stroke="currentColor" />
  </Icon>
);

// slogo svg 546:7049 (공급사 인증 보유)
export const NvShieldCheckIcon = ({ size = 14, ...props }: IconProps) => (
  <Icon size={size} grid={14} {...props}>
    <path d="M7 0.875L12.25 3.0625V6.825C12.25 9.8875 10.0625 12.3375 7 13.125C3.9375 12.3375 1.75 9.8875 1.75 6.825V3.0625L7 0.875Z" fill="currentColor" />
    <path d="M4.63672 7.1748L6.21172 8.74981L9.36172 5.4248" stroke="#fff" strokeWidth={1.6} />
  </Icon>
);

// database 546:8749 (워크플로우 · 연동 시스템). 시안은 32 x 36 상자에 오렌지 #FF9F00 선 2px.
export const NvDatabaseIcon = ({ size = 32, ...props }: IconProps) => (
  <svg width={size} height={(size * 36) / 32} viewBox="0 0 32 36" fill="none" aria-hidden {...props}>
    <path d="M31 6.0004C31 8.76204 24.2843 11.0008 16 11.0008C7.71573 11.0008 1 8.76204 1 6.0004M31 6.0004C31 3.23876 24.2843 1 16 1C7.71573 1 1 3.23876 1 6.0004M31 6.0004V29.3356C31 30.6618 29.4196 31.9337 26.6066 32.8714C23.7936 33.8092 19.9782 34.336 16 34.336C12.0218 34.336 8.20644 33.8092 5.3934 32.8714C2.58035 31.9337 1 30.6618 1 29.3356V6.0004M1 17.668C1 18.9942 2.58035 20.2661 5.3934 21.2038C8.20644 22.1416 12.0218 22.6684 16 22.6684C19.9782 22.6684 23.7936 22.1416 26.6066 21.2038C29.4196 20.2661 31 18.9942 31 17.668" stroke="#FF9F00" strokeWidth={2} strokeLinecap="round" />
  </svg>
);

// ── Figma ver.7 (07 워크플로우 · 검증 지표 · 닫기 아이콘) 공식 SVG (ver7/svg, 2026-10-14) ──
// max (Lucide) 847:55010 (워크플로우 [전체 보기] 버튼)
export const NvMaximizeIcon = ({ size = 16, ...props }: IconProps) => (
  <Icon size={size} grid={16} {...props}>
    <g stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
      <path d="M10 2H14V6" />
      <path d="M6 14H2V10" />
      <path d="M14.0026 2L9.33594 6.66667" />
      <path d="M2 13.9997L6.66667 9.33301" />
    </g>
  </Icon>
);

// user (Lucide) 847:55046 (사람 개입 칩 · 12 격자, 선 굵기 2)
export const NvUserSmallIcon = ({ size = 12, ...props }: IconProps) => (
  <Icon size={size} grid={12} {...props}>
    <g stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
      <path d="M9.5 10.5V9.5C9.5 8.96957 9.28929 8.46086 8.91421 8.08579C8.53914 7.71071 8.03043 7.5 7.5 7.5H4.5C3.96957 7.5 3.46086 7.71071 3.08579 8.08579C2.71071 8.46086 2.5 8.96957 2.5 9.5V10.5" />
      <path d="M6 5.5C7.10457 5.5 8 4.60457 8 3.5C8 2.39543 7.10457 1.5 6 1.5C4.89543 1.5 4 2.39543 4 3.5C4 4.60457 4.89543 5.5 6 5.5Z" />
    </g>
  </Icon>
);

// arrow (Lucide) 847:58192 (검증 지표 표 · 도입 후 앞 화살표, 16 격자)
export const NvArrowRightIcon = ({ size = 16, ...props }: IconProps) => (
  <Icon size={size} grid={16} {...props}>
    <g stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
      <path d="M3.33594 8H12.6693" />
      <path d="M8 3.33301L12.6667 7.99967L8 12.6663" />
    </g>
  </Icon>
);

// down (Lucide) 847:58198 (검증 지표 표 · 개선 칩 아래 화살표, 14 격자)
export const NvArrowDownIcon = ({ size = 14, ...props }: IconProps) => (
  <Icon size={size} grid={14} {...props}>
    <g stroke="currentColor" strokeWidth={2.2} strokeLinecap="round" strokeLinejoin="round">
      <path d="M7 2.91699V11.0837" />
      <path d="M11.0807 7L6.9974 11.0833L2.91406 7" />
    </g>
  </Icon>
);

// info (Lucide) 847:58235 (검증 지표 · 측정 기준 안내 박스, 18 격자)
export const NvInfoCircleIcon = ({ size = 18, ...props }: IconProps) => (
  <Icon size={size} grid={18} {...props}>
    <g stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
      <path d="M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5Z" />
      <path d="M9 12V9" />
      <path d="M9 6H9.0075" />
    </g>
  </Icon>
);

// x (Lucide · 닫기) 847:44787 (24px · 선 1.8) / 847:44963 (16px · 선 1.2 = 24 격자 1.8). 팝업 제목 줄은 24, 정의서 뷰어 [닫기] 버튼 안은 16.
export const NvLucideCloseIcon = ({ size = 24, ...props }: IconProps) => (
  <Icon size={size} grid={24} {...props}>
    <g stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
      <path d="M18 6L6 18" />
      <path d="M6 6L18 18" />
    </g>
  </Icon>
);

// 연동 시스템 카드 아이콘 (Figma ver.7 03-01 · 03-04, 62 x 59 · 주황 그라디언트) — 벡터 847:50644 (REST /v1/images svg, 2026-10-14)
export const NvAnalyticsPicto = ({ size = 62, ...props }: IconProps) => {
  const gid = `nv-analytics-${useId().replace(/[^a-zA-Z0-9]/g, "")}`;
  return (
    <svg width={size} height={(size * 59) / 62} viewBox="0 0 62 59" fill="none" aria-hidden {...props}>
      <path
        d="M62 56.3636V58.6182H0V0H2.25455V56.3636H62ZM23.7848 38.8414C26.7075 40.6478 30.1372 41.7091 33.8182 41.7091C44.3853 41.7091 52.9818 33.1115 52.9818 22.5455C52.9818 12.7433 45.5793 4.64757 36.0727 3.52641V5.8047C44.3322 6.91264 50.7273 13.9874 50.7273 22.5455C50.7273 31.8697 43.1424 39.4545 33.8182 39.4545C24.494 39.4545 16.9091 31.8697 16.9091 22.5455C16.9091 14.0774 23.1714 7.06454 31.3046 5.84428L32.9998 3.4232C22.8138 3.85637 14.6545 12.2556 14.6545 22.5455C14.6545 28.6227 17.5075 34.0376 21.9345 37.5512L11.9192 51.8545H14.673L23.7848 38.8414ZM20.2909 24.8V28.1729C20.8571 29.5284 21.6195 30.7818 22.5455 31.8961V24.8H20.2909ZM24.8 15.7818V34.0725C25.5038 34.6244 26.256 35.1153 27.0545 35.5329V15.7818H24.8ZM29.3091 9.01818V36.4828C30.0367 36.7188 30.7915 36.8882 31.5636 37.0082V9.01818H29.3091ZM33.8182 9.01818V37.2C34.5867 37.2 35.3358 37.1228 36.0727 37.0082V9.01818H33.8182ZM38.3273 22.4838V36.4828C39.1102 36.2289 39.8626 35.909 40.5818 35.5329V22.4838H38.3273ZM42.8364 24.8V34.0725C43.661 33.4259 44.4216 32.7016 45.0909 31.8961V24.8H42.8364Z"
        fill={`url(#${gid})`}
      />
      <defs>
        <linearGradient id={gid} x1="0.845453" y1="59.4637" x2="49.3307" y2="10.9784" gradientUnits="userSpaceOnUse">
          <stop stopColor="#FF9F00" />
          <stop offset="0.05089" stopColor="#FE9900" />
          <stop offset="0.466323" stopColor="#FD7204" />
          <stop offset="0.797112" stopColor="#FD5907" />
          <stop offset="1" stopColor="#FD5108" />
        </linearGradient>
      </defs>
    </svg>
  );
};
